(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-share-help')) {
    customElements.define('product-share-help', class ProductShareHelp extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.drawer = document.getElementById(this.dataset.drawerId);
        this.drawer?.addEventListener('drawer:afterHide', this.handleDrawerAfterHide, {
          signal: this.abortController.signal
        });
        document.addEventListener('shopify:block:select', this.handleBlockSelect, {
          signal: this.abortController.signal
        });
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect, {
          signal: this.abortController.signal
        });
        document.addEventListener('shopify:section:deselect', this.handleSectionDeselect, {
          signal: this.abortController.signal
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();

        if (this.drawer?.open) this.drawer.hide();
        if (this.drawer?.parentElement === document.body) this.appendChild(this.drawer);
      }

      get parentBlock() {
        return this.closest(`#shopify-block-${CSS.escape(this.dataset.blockId)}`);
      }

      getHelpItem(target) {
        const closestItem = target.closest?.('[data-product-help-entry]');
        if (closestItem) return closestItem;

        return target.querySelector?.(':scope > [data-product-help-entry]') || null;
      }

      closeDrawer(drawer, immediate = false) {
        if (!drawer.open) {
          if (immediate) drawer.hidden = true;
          return;
        }

        drawer.hide();
        if (immediate) drawer.hidden = true;
      }

      handleBlockSelect = (event) => {
        const drawer = this.drawer || document.getElementById(this.dataset.drawerId);
        const selectedItem = this.getHelpItem(event.target);
        if (!drawer) return;

        if (event.target === this.parentBlock) {
          this.closeDrawer(drawer, true);
          return;
        }

        if (!selectedItem || !drawer.contains(selectedItem)) {
          this.closeDrawer(drawer, true);
          return;
        }

        if (!drawer.open) drawer.show(null, false);
      };

      handleBlockDeselect = (event) => {
        const drawer = this.drawer || document.getElementById(this.dataset.drawerId);
        const deselectedItem = this.getHelpItem(event.target);
        if (!drawer || !deselectedItem || !drawer.contains(deselectedItem)) return;

        this.closeDrawer(drawer);
      };

      handleSectionDeselect = (event) => {
        const drawer = this.drawer || document.getElementById(this.dataset.drawerId);
        const section = this.closest('.shopify-section');
        if (!drawer || !section || event.target !== section) return;

        this.closeDrawer(drawer);
      };

      handleDrawerAfterHide = () => {
        if (!Shopify.designMode || !this.drawer || this.drawer.parentElement !== document.body) return;

        this.appendChild(this.drawer);
      };
    });
  }
  } catch(e) { console.error(e); }
})();

})();
